import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ChangeParticipantPresence, ChangeParticipantPresenceResponse, CreateMessageSingleResponse, CreateParticipantSingleResponse, CreateReadMessageSingleResponse, CreateReplySingleResponse, StoreAddParticipantRequest, StoreCreateMessageRequest, StoreCreateReplyRequest, StoreReadMessageRequest, StoreThreadIdsActionRequest, Thread, ThreadIdsSingleResponse } from '@lib/api/models/message';

export const selectedThread = signal<Thread|null>(null);

@Injectable({
    providedIn: 'root'
})


export class MessageService {

    private readonly _http = inject(HttpClient);

    addRemoveParticipant(participant: ChangeParticipantPresence) {
        return this._http.post<ChangeParticipantPresenceResponse>(`/api/addRemoveParticipant/`, participant);
    }

    getAllMessages(): Observable<Thread[]> {
        return this._http.get<Thread[]>('/api/getAllMessages');
    }

    createMessage(data: StoreCreateMessageRequest) {
        return this._http.post<CreateMessageSingleResponse>('/api/createMessage', data);
    }

    readMessage(data: StoreReadMessageRequest) {
        return this._http.post<CreateReadMessageSingleResponse>('/api/readMessage', data);
    }

    createReply(data: StoreCreateReplyRequest) {
        return this._http.post<CreateReplySingleResponse>('/api/createReply', data);
    }

    addParticipant(data: StoreAddParticipantRequest) {
        return this._http.post<CreateParticipantSingleResponse>('/api/addParticipant', data);
    }

    deleteThreads(threadIds: StoreThreadIdsActionRequest): Observable<ThreadIdsSingleResponse> {
        return this._http.request<ThreadIdsSingleResponse>('delete', '/api/deleteThreads', {
            body: threadIds
        });
    }
    
    readThreads(ids: string[]): Observable<ThreadIdsSingleResponse> {
        return this._http.patch<ThreadIdsSingleResponse>('/api/readThreads', { threadIds: ids });
    }

    unReadThreads(ids: string[]): Observable<ThreadIdsSingleResponse> {
        return this._http.patch<ThreadIdsSingleResponse>('/api/unReadThreads', { threadIds: ids });
    }
      
    
      
}
